import { HttpClient } from '@angular/common/http';
import { Component, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import { PageLayoutDataService } from 'src/app/submodules/angular-common/page-layout-data.service';
import { buildUrl } from 'submodules/engine-common/util';
import * as pkg from '../../../../../../package.json';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {

  appName;
  appVersion;
  apiVersion;
  authApiVersion;
  iamApiVersion;

  constructor(protected _injector: Injector) {
    this._injector.get(PageLayoutDataService).init({
      notMobileMaxWidth: 400,
      layoutType: 1,
      verticallyCentered:true,
      showBreadcrumbs:false})
  }

  async ngOnInit() {
    this.appName = pkg.name;
    this.appVersion = pkg.version;
    this.apiVersion = 'NOT AVAILABLE';
    this.authApiVersion = 'NOT AVAILABLE';
    this.iamApiVersion = 'NOT AVAILABLE';
    try {
      this.apiVersion = await this.getApiVersion()
    } catch (error) {
      console.log('API server not reachable');
    }
    try {
      this.authApiVersion = await this.getAuthApiVersion()
    } catch (error) {
      console.log('AUTH API server not reachable');
    }
    try {
      this.iamApiVersion = await this.getIamApiVersion()
    } catch (error) {
      console.log('IAM API server not reachable');
    }
    this._injector.get(PageLayoutDataService).loading = false;
  }

  getIamApiVersionObs(): Observable<any> {
    return this._injector.get(HttpClient).get<any>(
      buildUrl(
        this._injector.get(EnvironmentDataService).environment.getValue("endpoints.iamApi"),
        ["v1", "system", "version"],
        ["lc=it-IT"]
      )
    );
  }
  getIamApiVersion(): Promise<any> {
    return this.getIamApiVersionObs().toPromise()
  }

  getAuthApiVersionObs(): Observable<any> {
    return this._injector.get(HttpClient).get<any>(
      buildUrl(
        this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
        ["v1", "system", "version"],
        ["lc=it-IT"]
      )
    );
  }
  getAuthApiVersion(): Promise<any> {
    return this.getAuthApiVersionObs().toPromise()
  }

  getApiVersionObs(): Observable<any> {
    return this._injector.get(HttpClient).get<any>(
      buildUrl(
        this._injector.get(EnvironmentDataService).environment.getValue("endpoints.api"),
        ["v1", "system", "version"],
        ["lc=it-IT"]
      )
    );
  }
  getApiVersion(): Promise<any> {
    return this.getApiVersionObs().toPromise()
  }
}
